<template>
  <SchemaGuidePage
    :intro-blocks="settingGuideIntroBlocks"
    :sections="settingGuideSections"
    :image-map="resolvedImageMap"
  >
    <template #renderer="{ blocks, imageMap }">
      <SettingGuideRenderer
        :blocks="blocks"
        :imageMap="imageMap"
      />
    </template>
  </SchemaGuidePage>
</template>

<script setup>
import SettingGuideRenderer from "@/views/FileDoc/components/SettingGuideRenderer.vue";
import SchemaGuidePage from "@/views/FileDoc/components/SchemaGuidePage.vue";
import {settingGuideImages} from "@/views/FileDoc/components/guideImageLoaders";
import {
  settingGuideImageMap,
  settingGuideIntroBlocks,
  settingGuideSections,
} from "@/views/FileDoc/components/settingGuideSchema";

const resolveImageMap = (semanticImageMap, imageRegistry) => Object.freeze(
  Object.fromEntries(
    Object.entries(semanticImageMap).flatMap(([semanticKey, originalKey]) => {
      const imageSource = imageRegistry[originalKey]
      return imageSource ? [[semanticKey, imageSource]] : []
    }),
  ),
)

const resolvedImageMap = resolveImageMap(settingGuideImageMap, settingGuideImages)
</script>
